<template>
  <section class="section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-12">
                <h2 style="padding-bottom: 20px">PREGUNTAS MÁS FRECUENTES</h2>
              </div>
            </template>
            <template>
              <ol>
                <li>
                  <h4>¿Cómo puedo tener una Tarjeta +VIVOS?</h4>
                  <p>
                    Para obtener una Tarjeta +VIVOS debes ser un joven entre los 14 y 28 de edad del área metropolitana y acercarte a alguno de los puntos de entrega establecidos. Encuentra toda la información haciendo
                    <a
                      href="https://www.medellinjoven.com/reclama-ya-tu-tarjeta-vivos-y-aprovecha-los-descuentos-exclusivos-para-jovenes-5010"
                    >clic aquí</a>.
                  </p>
                </li>
                <li>
                  <h4>¿Dónde puedo reclamar una Tarjeta +VIVOS?</h4>
                  <p>
                    Conoce todos las fechas y los puntos de entrega establecidos haciendo
                    <a
                      href="https://drive.google.com/file/d/1a0JDPhR5Z0RJPL1g52qW-r24jF9Mxt1F/view?usp=sharing"
                    >clic aquí</a>.
                  </p>
                </li>
                <li>
                  <h4>¿Qué beneficios tengo con la Tarjeta +VIVOS?</h4>
                  <p>
                    Con la Tarjeta +VIVOS podrás disfrutar descuentos hasta del 50% en todas nuestras marcas aliadas. Te invitamos a que hagas
                    <a href="https://masvivos.medellinjoven.com/#/beneficios">clic aquí</a> y conozcas todos los aliados y sus descuentos, así mismo recuerda que cada una tiene unas condiciones que se deben cumplir a la hora de redimir el beneficio.
                  </p>
                </li>
                <li>
                  <h4>¿Tengo algún descuento con la Cívica del Metro?</h4>
                  <p>No, la Cívica +VIVOS te permite tener integrado el sistema de transporte Metro en una sola Tarjeta, pero no tiene tarifa especial ya que es una Cívica Al Portador.</p>
                </li>
                <li>
                  <h4>¿Qué hacer si en un establecimiento aliado no me aceptan la Tarjeta +VIVOS?</h4>
                  <p>
                    Ten presente que en los primeros meses desde el lanzamiento de la Tarjeta esto puede suceder, ya que posiblemente los trabajadores de algunos establecimientos todavía no reconocen la Tarjeta +VIVOS. Si se te presenta esta situación te invitamos a que primero le cuentes a la persona que te está atendiendo en qué consiste la Tarjeta y le muestres el beneficio de la marca que aparece haciendo
                    <a href="https://masvivos.medellinjoven.com/#/beneficios">clic aquí</a>. También muéstrale tu documento de identidad ya que en varias marcas tendrán tus datos en el sistema y éste les informará del beneficio que tienes. Si esto no funciona, pídele respetuosamente hablar con el administrador del lugar o envíanos un correo a masvivos@medellinjoven.com y cuéntanos la situación.
                  </p>
                </li>
                <li>
                  <h4>¿Puedo tener la tarjeta si no soy de Medellín?</h4>
                  <p>Sí, puedes tener tu Tarjeta +VIVOS si no eres de Medellín siempre y cuando residas, estudies o trabajes en la ciudad. Para hacerlo debes mostrar tu documentación o permisos de residencia en caso de ser extranjero y tener toda la documentación al día.</p>
                </li>
                <li>
                  <h4>¿Por qué debo esperar 8 días después de activarla para usarla?</h4>
                  <p>Esto se debe a que varias marcas deben subir tu información a sus sistemas y esto puede tardar hasta 8 días.</p>
                </li>
                <li>
                  <h4>¿Cómo activar la Tarjeta +VIVOS?</h4>
                  <p>
                    Haz
                    <a href="https://masvivos.medellinjoven.com/#/registro">clic aquí</a> e ingresa el código de tu tarjeta +VIVOS que se encuentra al reverso y está identificado como número Civ. Completa todo el formulario y podrás disfrutar de todos los beneficios a los 8 días siguientes después de la activación.
                  </p>
                </li>
                <li>
                  <h4>Intenté activar mi Tarjeta +VIVOS y ya me encuentratro registrado, pero no recibí el código de verificación de identidad ¿Qué puedo hacer?</h4>
                  <p>Verifica que el menaje enviado no se encuentre en tu carpeta de SPAM y que tu correo existente en la plataforma se encuentre escrito correctamente.</p>
                </li>
                <li>
                  <h4>Intenté activar mi Tarjeta +VIVOS y ya me encuentro registrado, pero ya no tengo acceso al correo que se encuentra asociado a mi número de identificación o mi correo se encuentra mal escrito ¿Qué puedo hacer?</h4>
                  <p>Escríbenos a soporte.masvivos@medellijoven.com describiendo tu problema de activación y te ayudarémos a solucionarlo con la mayor brevedad posible.</p>
                </li>
                <li>
                  <h4>Intenté activar mi Tarjeta +VIVOS pero la plataforma me indica que el código ya fue utilizado ¿Qué puedo hacer?</h4>
                  <p>Escríbenos a soporte.masvivos@medellijoven.com describiendo tu problema de activación y te ayudarémos a solucionarlo con la mayor brevedad posible.</p>
                </li>
                <li>
                  <h4>No puedo ingresar con mi usuario y contraseña</h4>
                  <p>Ten presente que la pestaña de Aliados es únicamente para las marcas que brindan beneficios a los jóvenes. En este momento estamos trabajando para que puedas acceder con tu correo y la clave que elegiste y ver todos los beneficios que has redimido.</p>
                </li>
                <li>
                  <h4>¿Cómo puedo ser una marca aliada?</h4>
                  <p>Escríbenos a masvivos@medellinjoven.com contándonos cuál es tu marca y qué beneficio podrías ofrecerle a los jóvenes portadores de la Tarjeta +VIVOS.</p>
                </li>
              </ol>
            </template>
            <template></template>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
const axios = require("axios");
const moment = require("moment");

import Modal from "@/components/Modal.vue";

export default {
  data() {
    return {
      errors: [],
      loading: false,
      sectors: [
        {
          id: 1,
          name: "Comuna 1 - Popular"
        },
        {
          id: 2,
          name: "Comuna 2 - Santa Cruz"
        },
        {
          id: 3,
          name: "Comuna 3 - Manrique"
        },
        {
          id: 4,
          name: "Comuna 4 - Aranjuez"
        },
        {
          id: 5,
          name: "Comuna 5 - Castilla"
        },
        {
          id: 6,
          name: "Comuna 6 - Doce de Octubre"
        },
        {
          id: 7,
          name: "Comuna 7 - Robledo"
        },
        {
          id: 8,
          name: "Comuna 8 - Villa Hermosa"
        },
        {
          id: 9,
          name: "Comuna 9 - Buenos Aires"
        },
        {
          id: 10,
          name: "Comuna 10 - La Candelaria"
        },
        {
          id: 11,
          name: "Comuna 11 - Laureles Estadio"
        },
        {
          id: 12,
          name: "Comuna 12 - La América"
        },
        {
          id: 13,
          name: "Comuna 13 - San Javier"
        },
        {
          id: 14,
          name: "Comuna 14 - El Poblado"
        },
        {
          id: 15,
          name: "Comuna 15 - Guayabal"
        },
        {
          id: 16,
          name: "Comuna 16 - Belén"
        },
        {
          id: 50,
          name: "Comuna 50 - Corregimiento de San Sebastián de Palmitas"
        },
        {
          id: 60,
          name: "Comuna 60 - Corregimiento de San Cristóbal"
        },
        {
          id: 70,
          name: "Comuna 70 - Corregimiento de Altavista"
        },
        {
          id: 80,
          name: "Comuna 80 - Corregimiento de San Antonio de Prado"
        },
        {
          id: 90,
          name: "Comuna 90 - Corregimiento de Santa Elena"
        },
        {
          id: 100,
          name: "Otro municipio"
        }
      ],
      identification_types: [
        "Cédula",
        "Pasaporte",
        "Registro de Nacimiento",
        "Tarjeta de Identidad"
      ],
      user: {
        first_name: "",
        last_name: "",
        identification_type: "",
        identification_number: "",
        email: "",
        phone: ""
      }
    };
  },
  components: {},
  methods: {
    async validateForm() {
      this.errors = [];

      if (!this.genuine_civ_code) {
        return false;
      }
      // Required
      if (!this.user.identification_number)
        this.errors.push("El número de identificación es obligatorio");
      if (!this.user.first_name) this.errors.push("El nombre es obligatorio");
      if (!this.user.last_name) this.errors.push("El apellido es obligatorio");
      if (!this.user.identification_type)
        this.errors.push("El tipo de identificación es obligatorio");
      if (!this.user.email)
        this.errors.push("El correo electrónico obligatorio");
      if (this.errors.length) {
        return false;
      }

      if (!/^[0-9a-zA-Z_]{1,16}$/.test(this.user.identification_number))
        this.errors.push("El número de identificación es incorrecto");

      if (
        !/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
          this.user.email
        )
      )
        this.errors.push("El correo electrónico es incorrecto");

      if (this.errors.length) {
        return false;
      } else {
        return this.sendRequest();
      }
    },
    async sendRequest() {
      this.loading = true;
      var user = this.user;

      // try {
      //   var response = await axios.put(
      //     "https://hgogjz2lrh.execute-api.us-west-2.amazonaws.com/api/users/inscription",
      //     user
      //   );

      //   switch (response.data) {
      //     case "done":
      //       alert("Has sido registrado exitosamente. En 8 días hábiles podrás empezar a disfrutar de todos los beneficios y descuentos. Pronto podrás iniciar sesión y obtener más información sobre tu cuenta.");
      //       this.$router.push('/beneficios');
      //       break;
      //     case "InvalidParameterException":
      //       this.errors.push("Existe un error en uno de los campos del formulario, por favor, verifique e inténtelo nuevamente.");
      //       break;
      //     case "InvalidPasswordException":
      //       this.errors.push("La contraseña debe tener al menos 8 caracteres e incluir letras minúsculas y números");
      //       break;
      //     case "error_cognito":
      //       this.errors.push("Tuvimos un fallo al intentar crear su usuario en el sistema");
      //       break;
      //     case "error_saving_data":
      //       this.errors.push("Tuvimos un fallo actualizar su información");
      //       break;

      //     case "error_card_mas_vivos":
      //       this.errors.push("Ocurrió un error intentando registrar la tarjeta");
      //       break;
      //   }
      //   this.loading = false;
      // } catch (err) {
      //   console.log(err);
      //   this.loading = false;
      // }
    }
  },
  mounted() {}
};
</script>
<style>
</style>
